import { render, staticRenderFns } from "./ButtonSelectComponent.vue?vue&type=template&id=23266ddd&scoped=true"
import script from "./ButtonSelectComponent.vue?vue&type=script&lang=ts"
export * from "./ButtonSelectComponent.vue?vue&type=script&lang=ts"
import style0 from "./ButtonSelectComponent.vue?vue&type=style&index=0&id=23266ddd&prod&scoped=true&lang=css"
import style1 from "./ButtonSelectComponent.vue?vue&type=style&index=1&id=23266ddd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23266ddd",
  null
  
)

export default component.exports